import "jquery";
import _ from "lodash";
import "./directory.scss";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/js/fontawesome";
import "@fortawesome/fontawesome-free/js/solid";
import "@fortawesome/fontawesome-free/js/regular";
import "@fortawesome/fontawesome-free/js/brands";
import page_template from "../../layouts/page-template";
import page_header from "../header/header";
import page_footer from "../footer/footer";
import coffee_main from "../coffee.main";
import { computeStyles } from "@popperjs/core";
import no_image from "../../assets/noImg/circle_photo.png";

const page_template_content = document.getElementById(
  "js__page_template_content"
);
const page_template_header_title = document.getElementById(
  "js__page_template_header_title"
);
const base_url = coffee_main.base_url;
const id_season = coffee_main.id_season;
const page_title = "Directorio";

//set page template and loader
page_template.setPageTemplate();

//size menu items on sidebar
page_header.setPageTemplate();

//content for page
//page title
coffee_main.createSectionTitle(page_title, page_template_header_title);

/**** main content start ****/

let title = document.createElement("h1");
title.innerText = "Directorio";
page_template_content.appendChild(title);

let directory = document.createElement("div");
directory.classList.add("row");
page_template_content.appendChild(directory);

showDirectory(directory);

/**** main content end ****/

//page_footer
page_footer.render(base_url, id_season);

//hide loader at the end, always at the bottom of this index file
$(window).on("load", function () {
  page_template.hideLoader();
});

//********* page functions start ******/
async function showDirectory(container) {
  await getDirectory().then((response) => {
    response.items.forEach(function (item, index) {
      var email = item.contact === null ? "N/D" : item.contact.email;
      var image =
        item.full_url_image === "/img/no-image.jpg"
          ? no_image
          : base_url + item.full_url_image;

      let contact = document.createElement("div");
      contact.classList.add("col-sm-12", "col-md-4", "col-lg-4", "contact");

      let img = document.createElement("img");
      img.src = image;
      contact.appendChild(img);

      let content = document.createElement("div");
      content.classList.add("line_height_1_5");
      content.innerText = item.text;
      contact.appendChild(content);

      content = document.createElement("div");
      content.classList.add("line_height_1_5");
      content.innerText = email;
      contact.appendChild(content);

      contact.appendChild(document.createElement("hr"));

      content = document.createElement("div");
      content.classList.add("line_height_1_5");
      content.innerText = item.title;
      contact.appendChild(content);

      container.appendChild(contact);
    });
  });
}

//ajax
async function getDirectory() {
  var ajax_data = {
    id_category: 227
  };

  return $.ajax({
    type: "POST",
    url: base_url + "/cms/entries/category",
    data: ajax_data
  });
}
